import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { setLenderData } from '../../utils/demoDataManager';
import './onboardlender.css';

const OnboardLender = () => {
  const history = useHistory();
  const [formData, setFormData] = useState({
    totalAmount: '',
    preferredAssetTypes: [],
    maxLtv: 70,
    minInterestRate: 6.0,
    maxTerm: 36
  });

  const assetTypes = [
    { id: 'commercial-property', label: 'Commercial Property', icon: '🏢' },
    { id: 'trucks', label: 'Trucks & Vehicles', icon: '🚛' },
    { id: 'inventory', label: 'Inventory', icon: '📦' },
    { id: 'equipment', label: 'Equipment', icon: '⚙️' }
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleAssetTypeToggle = (assetType) => {
    setFormData(prev => ({
      ...prev,
      preferredAssetTypes: prev.preferredAssetTypes.includes(assetType)
        ? prev.preferredAssetTypes.filter(type => type !== assetType)
        : [...prev.preferredAssetTypes, assetType]
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Save lender data to cookies
    const lenderData = {
      ...formData,
      totalAmount: parseFloat(formData.totalAmount),
      maxLtv: formData.maxLtv / 100, // Convert to decimal
      isDefault: false
    };
    
    setLenderData(lenderData);
    
    // Redirect to lender dashboard
    history.push('/jo-xyz-demo/lender-dashboard');
  };

  return (
    <div className="jo-xyz-demo-onboard-lender">
      <div className="jo-xyz-demo-onboard-lender__header">
        <h1>Lender Onboarding</h1>
        <p>Tell us about your investment preferences and lending criteria</p>
      </div>

      <form onSubmit={handleSubmit} className="jo-xyz-demo-onboard-lender__form">
        <div className="jo-xyz-demo-form-section">
          <h2>Investment Amount</h2>
          <div className="jo-xyz-demo-form-group">
            <label htmlFor="totalAmount">Total Amount to Invest</label>
            <input
              type="number"
              id="totalAmount"
              name="totalAmount"
              value={formData.totalAmount}
              onChange={handleInputChange}
              placeholder="e.g., 5000000"
              required
            />
          </div>
        </div>

        <div className="jo-xyz-demo-form-section">
          <h2>Preferred Asset Types</h2>
          <p>Select the types of collateral you're comfortable accepting:</p>
          <div className="jo-xyz-demo-asset-types-grid">
            {assetTypes.map(assetType => (
              <div
                key={assetType.id}
                className={`jo-xyz-demo-asset-type-card ${
                  formData.preferredAssetTypes.includes(assetType.id) ? 'jo-xyz-demo-asset-type-card--selected' : ''
                }`}
                onClick={() => handleAssetTypeToggle(assetType.id)}
              >
                <div className="jo-xyz-demo-asset-type-card__icon">{assetType.icon}</div>
                <div className="jo-xyz-demo-asset-type-card__label">{assetType.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="jo-xyz-demo-form-section">
          <h2>Lending Criteria</h2>
          <div className="jo-xyz-demo-criteria-grid">
            <div className="jo-xyz-demo-form-group">
              <label htmlFor="maxLtv">Maximum Loan-to-Value Ratio</label>
              <input
                type="range"
                id="maxLtv"
                name="maxLtv"
                min="50"
                max="90"
                value={formData.maxLtv}
                onChange={handleInputChange}
              />
              <div className="jo-xyz-demo-range-value">{formData.maxLtv}%</div>
            </div>

            <div className="jo-xyz-demo-form-group">
              <label htmlFor="minInterestRate">Minimum Interest Rate</label>
              <input
                type="number"
                id="minInterestRate"
                name="minInterestRate"
                min="3"
                max="15"
                step="0.1"
                value={formData.minInterestRate}
                onChange={handleInputChange}
              />
              <span className="jo-xyz-demo-input-suffix">%</span>
            </div>

            <div className="jo-xyz-demo-form-group">
              <label htmlFor="maxTerm">Maximum Loan Term</label>
              <input
                type="number"
                id="maxTerm"
                name="maxTerm"
                min="6"
                max="60"
                value={formData.maxTerm}
                onChange={handleInputChange}
              />
              <span className="jo-xyz-demo-input-suffix">months</span>
            </div>
          </div>
        </div>

        <div className="jo-xyz-demo-form-actions">
          <button
            type="button"
            className="jo-xyz-demo-btn jo-xyz-demo-btn--secondary"
            onClick={() => history.push('/jo-xyz-demo')}
          >
            Back to Home
          </button>
          <button
            type="submit"
            className="jo-xyz-demo-btn jo-xyz-demo-btn--primary"
            disabled={formData.preferredAssetTypes.length === 0}
          >
            Complete Onboarding
          </button>
        </div>
      </form>
    </div>
  );
};

export default OnboardLender;
